<template>
  <modal name="EmailHistoriesManagementModal" class="custom-modal" :width="'75%'" :height="'auto'"
              :scrollable="true" :pivotX="1.0" :minWidth="900" :minHeight="900" @before-open="beforeOpen" @before-close="beforeClose"
              :clickToClose="true" >
    <div class="email-histories-page">
      <div class="hisories-page-header margin-side">
        <div class="btn-back-wrapper">
          <div class="btn-back icon-back" @click="cancelClick"></div>
        </div>
        <div class="page-title h2-text">Email History</div>
        <div class="tab-wrapper">
          <a href="javascript: void(0);" class="tab-name" :class="{'active': !isParticipantTab}" @click="handleChangeTableClick(false)"><span class="text">On Site Contact</span></a>
          <a href="javascript: void(0);" class="tab-name" :class="{'active': isParticipantTab}" @click="handleChangeTableClick(true)"><span class="text">Participant</span></a>
        </div>
      </div>

      <div class="histories-page-body">
        <div class="ems-table margin-side">
          <div v-if="isParticipantTab" class="participant-table-container">
            <div class="search-section ems-input-wrapper">
              <input class="input" placeholder="Search for emails" v-model="keyword">
            </div>
            <div class="table-participant-container">
              <div class="table-header">
                <div class="row">
                  <template v-for="(col, index) in participantColsHeader">
                    <HeaderColumnEMS :headerObject="col" :class="col.className"
                                    :showResizeLine="index + 1 != participantColsHeader.length"
                                    :showIcon="index + 1 != participantColsHeader.length"
                                    :sortObject="sortObject"
                                    :styleObject="{'width': columnWidth.emailTemplate.size ? (columnWidth.emailTemplate.size + 'px') : participantColsHeader.width}"
                                    @CHANGE_SORT_OPTION="handleSortChange"></HeaderColumnEMS>
                  </template>
                </div>
              </div>
              <div class="ems-table-body">
                <div v-for="h in histories" class="ems-row">
                  <div class="field-value value-text" :style="{'width': columnWidth.emailTemplate.size ? (columnWidth.emailTemplate.size + 'px') : '16.67%'}">{{h.time | dateFormatMMDDYY}}</div>
                  <div class="field-value value-text" :style="{'width': columnWidth.emailTemplate.size ? (columnWidth.emailTemplate.size + 'px') : '16.67%'}">{{h.template | templateName}}</div>
                  <div class="field-value value-text" :style="{'width': columnWidth.emailTemplate.size ? (columnWidth.emailTemplate.size + 'px') : '16.67%'}">{{h.firstName}}</div>
                  <div class="field-value value-text" :style="{'width': columnWidth.emailTemplate.size ? (columnWidth.emailTemplate.size + 'px') : '16.67%'}">{{h.lastName}}</div>
                  <div class="field-value value-text" :style="{'width': columnWidth.emailTemplate.size ? (columnWidth.emailTemplate.size + 'px') : '16.67%'}">{{h.recipients}}</div>
                  <div class="field-value value-text resend-btn-wrapper"
                      :style="{'width': columnWidth.emailTemplate.size ? (columnWidth.emailTemplate.size + 'px') : '16.67%'}">
                    <button class="ap-btn secondary resend-btn" v-if="h.template != 'CANCELLATION'" @click="handleResendEmail(h)">Resend</button>
                  </div>
                </div>
                <infinite-loading @infinite="infiniteHandler" :distance="100">
                  <Spinner slot="spinner"></Spinner>
                  <div slot="no-more" class="infinite-status-prompt"></div>
                  <div slot="no-results" class="infinite-status-prompt"></div>
                </infinite-loading>
              </div>
            </div>
          </div>
          <div v-else class="histories-table-container">
            <EmailHistoriesHeader></EmailHistoriesHeader>
            <div class="ems-table-body" id="ems-table-body">
              <div v-for="h in histories" class="ems-row" :key="h.id">
                <div class="field-value value-text padding-left-40px" :style="{'width': columnWidth.sentDate.size ? (columnWidth.sentDate.size + 'px') : '13%'}">{{h.time | dateFormatMMDDYY}}</div>
                <div class="field-value value-text" :style="{'width': columnWidth.emailTemplate.size ? (columnWidth.emailTemplate.size + 'px') : '17%'}">{{h.template | templateName}}</div>
                <div class="field-value value-text" :style="{'width': columnWidth.relatedEvent.size ? (columnWidth.relatedEvent.size + 'px') : '28%'}">{{h.relatedEvents.join(', ')}}</div>
                <div class="field-value value-text" :style="{'width': columnWidth.recipients.size ? (columnWidth.recipients.size + 'px') : '28%'}">{{h.recipients}}</div>
                <div class="field-value value-text" :style="{'width': columnWidth.actions.size ? (columnWidth.actions.size + 'px') : '14%', 'text-align': 'right'}">
                  <span class="action-text" @click="goToEventDetails(h.id)">View Details</span>
                </div>
              </div>
              <infinite-loading @infinite="infiniteHandler" :distance="100">
                <Spinner slot="spinner"></Spinner>
                <div slot="no-more" class="infinite-status-prompt"></div>
                <div slot="no-results" class="infinite-status-prompt"></div>
              </infinite-loading>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
  import EmailHistoriesHeader from '@/components/events/EmailHistoriesHeader';
  import {mapActions, mapGetters} from 'vuex';
  // import emailTemplateConsts from '@/store/constants/emailTemplateType';
  // import consts from '../../_consts';
  import _ from 'lodash';
  import emailHistoryConstants from '@/store/modules/emailHistory/constants';
  import storeConstants from '@/store/constants';
  import arrHelper from '@/utils/array-helper';
  import HeaderColumnEMS from '@/components/commons/HeaderColumnEMS';
  import Spinner from '@/components/commons/Spinner';
  import InfiniteLoading from 'vue-infinite-loading';
  export default {
    name: 'Email-Histories-Management-Page',
    components: {
      EmailHistoriesHeader,
      HeaderColumnEMS,
      InfiniteLoading,
      Spinner
    },
    data () {
      return {
        eventId: null,
        event: {},
        histories: [],
        isParticipantTab: false,
        participantColsHeader: [
          {
            displayName: 'Last Sent Date',
            internalName: 'lastModifiedAt',
            showIcon: true,
            className: ['col-md-2'],
            width: '16.67%%'
          },
          {
            displayName: 'Email Template',
            internalName: 'templateType',
            showIcon: true,
            className: ['col-md-2'],
            width: '16.67%%'
          },
          {
            displayName: 'First Name',
            internalName: 'firstName',
            showIcon: true,
            className: ['col-md-2'],
            width: '16.67%%'
          },
          {
            displayName: 'Last Name',
            internalName: 'lastName',
            showIcon: true,
            className: ['col-md-2'],
            width: '16.67%%'
          },
          {
            displayName: 'Email',
            internalName: 'recipients',
            showIcon: true,
            className: ['col-md-2'],
            width: '16.67%%'
          },
          {
            displayName: '',
            showIcon: true,
            className: ['col-md-2'],
            width: '16.67%%'
          }
        ],
        sortObject: {
          fieldName: '',
          reverse: false
        },
        pagingOption: {
          pageNum: 1,
          pageSize: 10,
          sortType: null,
          sortReverse: false
        },
        keyword: ''
      };
    },
    filters: {
      filterRelatedEventsName: function (listRelatedEvents) {
        let result = '';
        listRelatedEvents.forEach((index, element) => {
        });
        return result;
      }
    },
    computed: {
      ...mapGetters({
        columnWidth: 'GETTER_GET_COLUMN_TABLE_EMAIL_HISTORIES'
      })
    },
    methods: {
      beforeOpen (params) {
        if (params.params && params.params.eventId) {
          this.eventId = params.params.eventId;
          this.isManageDetails = params.params.isManageDetails;
        }
      },
      goToEventDetails (historyId) {
        this.$router.push({name: 'EmailHistoryDetailsManagement', params: {id: historyId}});
      },
      infiniteHandler ($state) {
        this.pagingOption.pageNum++;
        this.getData(true)
          .then((res) => {
            // debugger;
            if (res && (this.pagingOption.pageNum + 1) * this.pagingOption.pageSize >= res.total) {
              $state.complete();
            } else {
              $state.loaded();
            }
          });
      },
      cancelClick () {
        this.$modal.hide('EmailHistoriesManagementModal');
      },
      handleChangeTableClick (isParticipantTab) {
        this.isParticipantTab = isParticipantTab;
        this.pagingOption = {
          pageNum: 1,
          pageSize: 10,
          sortType: null,
          sortReverse: false
        };
        this.histories = [];
        this.getData();
      },
      handleResendEmail (historyEmail) {
        this.resendEmail(historyEmail.id).then((response) => {
        }).catch(err => {
          console.log('error=', err);
          this.$toast.success('Resend email failure.', '', {
            ...this.$toastOpt.optError
          });
        });
      },
      getData () {
        return new Promise((resolve, reject) => {
          let params = {
            params: {
              isParticipant: this.isParticipantTab,
              eventId: this.eventId,
              keyword: this.keyword,
              ...this.pagingOption
            }
          };
          this.getEventHistoriesById(params).then(response => {
            if (response.message === null) {
              response.historyList.forEach(element => {
                this.histories.push({
                  ...element,
                  id: element.id,
                  time: element.lastModifiedAt,
                  template: element.templateType,
                  relatedEvents: element.relatedEvents.map(r => r.eventName),
                  recipients: element.recipients.replace(',', ', ')
                })
              });
              this.histories.sort((a, b) => a.time - b.time);
            }
            resolve(response);
          });
        });
      },
      handleSortChange (sortObj) {
        this.sortObject.reverse = sortObj.fieldName === this.sortObject.fieldName ? !this.sortObject.reverse : false;
        this.sortObject.fieldName = sortObj.fieldName;
        let type = arrHelper.getMappingObjectType(sortObj.fieldName);
        // this.histories.sort(arrHelper.sortFunction(sortObj.fieldName, this.sortObject.reverse, type));
        this.histories.sort(arrHelper.sortFunction(sortObj.fieldName, this.sortObject.reverse, type));
      },
      ...mapActions({
        getEventHistoriesById: 'ACTION_GET_EVENT_HISTORIES_BY_ID',
        getDefaultEmailTemplate: 'ACTION_GET_DEFAULT_EMAIL_TEMPLATE',
        sendOnSiteContactEmail: 'ACTION_SEND_ON_SITE_CONTACT_EMAIL'
      }),
      ...mapActions(storeConstants.store.EMAIL_HISTORY, {
        resendEmail: [emailHistoryConstants.ACTION_RESEND_EMAIL]
      })
    },
    created () {
      this.$bus.$on('CHANGE_EMAIL_HISTORY_SORT', (sortOption) => {
        this.histories.sort(arrHelper.sortFunction(sortOption.sortType, sortOption.sortReverse));
      })
    },
    mounted () { },
    watch: {
      keyword: _.debounce(function () {
        this.histories = [];
        this.pagingOption.pageNum = 1;
        this.getData();
      }, 300)
    }
  };
</script>

<style lang="less">
  @import '../../styles/variables.less';
</style>



// WEBPACK FOOTER //
// EmailHistoriesManagement.vue?49a3587d